var exports = {
  "kL": "x61f99309--bae088--container",
  "vW": "x61f99309--bae088--inner",
  "B$": "x61f99309--bae088--gallery-container",
  "nV": "x61f99309--bae088--gallery",
  "BN": "x61f99309--bae088--container-animation",
  "H1": "x61f99309--bae088--scroll-left-right",
  "OK": "x61f99309--bae088--round-button-left",
  "hS": "x61f99309--bae088--round-button-right",
  "AA": "x61f99309--bae088--button-animation",
  "QL": "x61f99309--bae088--button-hidden",
  "R": "x61f99309--bae088--hidden",
};

module.exports = exports;
